// Robust order-date resolution shared by the orders surfaces.
//
// The old inline expression (`dt && dt.includes(' ') && ...`) required a
// SPACE in the date string, so date-only ("2026-08-21") or ISO
// ("...T00:00:00") inputs silently fell back to TODAY. A note added to a
// previous-date appointment was stamped with today's date, detached from
// that appointment, and "disappeared" from its date-filtered views
// (QA 2026-08-24). First matching candidate wins; today is the last resort.
export const resolveOrderDate = (...cands) => {
  for (const c of cands) {
    if (!c) continue;
    const d0 = String(c).split(' ')[0].split('T')[0];
    if (!isNaN(Date.parse(d0))) return d0;
  }
  return new Date().toISOString().split('T')[0];
};

export default resolveOrderDate;
